import FixedAssetAPI from './_fixedAssetApi.js';

class FAIncrementAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaIncrements';
}

export default new FAIncrementAPI();
